<div >

  <div *ngFor="let md of subtasks ; let i=index; let last=last" class="text-left">

    <div class="flex flex-row text-lg gap-3">

      <div class="w-8 flex-shrink-0 text-center">
        <fa-icon *ngIf="md.progress.status == 'PENDING'" class="text-muted" [icon]="['far', 'circle']">
        </fa-icon>
        <fa-icon *ngIf="md.progress.status == 'ATTEMPTING'" icon="circle-half-stroke">
        </fa-icon>
        <fa-icon *ngIf="md.progress.status == 'AWAITING_ASSESSMENT'" [icon]="(assessing) ? 'circle-exclamation' : 'circle-check'">
        </fa-icon>
        <span *ngIf="md.progress.status == 'COMPLETED'">
          <fa-icon *ngIf="md.progress.assessment == 'POOR'" class="text-negative" icon="face-meh">
          </fa-icon>
          <fa-icon *ngIf="md.progress.assessment == 'OK'" class="text-amber" icon="face-smile">
          </fa-icon>
          <fa-icon *ngIf="md.progress.assessment == 'GOOD'" class="text-positive" icon="face-grin-stars">
          </fa-icon>
        </span>
      </div>

      <div class="grow">
          <a (click)="setSubtaskIndex(i)">
            <span *ngIf="md.subtask.bonus" class="text-yellow-200" >
              <fa-icon icon="star" class="mr-1"></fa-icon> Bonus:
            </span>
            {{md.subtask.name}}
          </a>
      </div>
    </div>

    <div class="flex flex-row gap-3 items-stretch">

      <div class="w-8 flex flex-row justify-center">
        <div *ngIf="!last" class="border-r-4 border-dotted border-slate-500 h-full"></div>
      </div>

      <div class="grow mt-2 mb-6 overflow-hidden" >
        <div *ngIf="i===subtaskIndex" [@fadeInOut]>

          <div *ngIf="!assessing" class="text-sm mb-6">
            <app-class-task-rewards [rewards]="md.subtask.rewards"></app-class-task-rewards>
          </div>

          <div *ngIf="md.progress.status == 'PENDING'" class="mt-3 text-lg">
            <button mat-button color="primary" (click)="updateSubtaskProgress(i, 'ATTEMPTING')" >
              <span *ngIf="!assessing">Get started</span>
              <span *ngIf="assessing">Mark as started</span>
            </button>
          </div>

          <div *ngIf="md.progress.status == 'ATTEMPTING'" class="mt-3 text-lg">
            <button mat-button color="primary"  (click)="updateSubtaskProgress(i, 'AWAITING_ASSESSMENT')">
              Mark as completed
            </button>
          </div>

          <div *ngIf="md.progress.status == 'AWAITING_ASSESSMENT'" class="mt-3">

            <span *ngIf="!assessing">Completed, awaiting feedback</span>
            <span *ngIf="assessing">Completed, please give feedback:</span>

            <p *ngIf="!assessing && !last" class="text-muted text-sm">
              Feel free to move onto the next task
            </p>

            <div *ngIf="assessing" class="mt-3 flex flex-col gap-3 text-lg">
              <div>
                <a class="text-negative" matTooltip="Mark as poor" (click)="updateSubtaskProgress(i, 'COMPLETED', 'POOR')">
                  <fa-icon icon="face-meh"></fa-icon> Poor
                </a>
              </div>
              <div>
                <a class="text-amber" matTooltip="Mark as ok" (click)="updateSubtaskProgress(i, 'COMPLETED', 'OK')">
                  <fa-icon icon="face-smile" ></fa-icon> Ok
                </a>
              </div>
              <div>
                <a class="text-positive" matTooltip="Mark as good" (click)="updateSubtaskProgress(i, 'COMPLETED', 'GOOD')">
                  <fa-icon icon="face-grin-stars" ></fa-icon> Good
                </a>
              </div>
              <p>
                <a class="" matTooltip="Request another attempt" (click)="updateSubtaskProgress(i, 'ATTEMPTING')">
                  <fa-icon icon="rotate-left" ></fa-icon> Try again
                </a>
              </p>
            </div>

          </div>

          <span *ngIf="md.progress.status == 'COMPLETED'">

            <span *ngIf="md.progress.assessment == 'POOR'">
              Completed to a <strong class="text-negative">poor</strong> standard
            </span>

            <span *ngIf="md.progress.assessment == 'OK'">
              Completed to an <strong class="text-amber">ok</strong> standard
            </span>

            <span *ngIf="md.progress.assessment == 'GOOD'">
              Completed to a <strong class="text-positive">good</strong> standard
            </span>

            <p *ngIf="assessing" class="mt-3">
              <a (click)="updateSubtaskProgress(i, 'AWAITING_ASSESSMENT', undefined)">
                <fa-icon icon="rotate-left"></fa-icon>
                Reassess
              </a>
            </p>

          </span>
        </div>
      </div>

    </div>


  </div>

</div>
